import { Model } from "@ofqual/portal-core/core/types";

export type CommissionModel = {
    id: string;
    createdDate: string;
    modifiedDate: string;
    createdByUpn: string;
    createdByDisplayName: string;
    modifiedByUpn: string;
    modifiedByDisplayName: string;
    referenceNumber: string;
    status: number;
    title: string;
    description: string;
    rateOfPay?: number | null;
    purchaseOrderNumber: string | null;
    assignedSpecialistId: string | null;
    forecastedStartDate: Date;
    forecastedEndDate: Date;
    estimatedNumberOfDaysRequired: number;
    assignedManagers: string;
    commissioningCategories: number;
    assignedCommissioningTeamId?: number | null;
    actualNumDaysWorked: number;
    actualCost: number;
    closedByUpn: string | null;
};

export const fromApiModel = (model: Model): CommissionModel => {
    return {
        ...model,
    } as CommissionModel;
};

export const toApiModel = (item: CommissionModel): Model => {
    return {
        ...item,
    } as Model;
};

export enum CommissionStatus {
    "Draft" = 0,
    "Forecasted",
    "In progress",
    "Closed",
    "Cancelled"
}
